// Utility for JWT token management

const JWT_TOKEN_KEY = 'ee_jwt_token';
const JWT_TOKEN_EXP_KEY = 'ee_jwt_token_exp';

// expirationTime from backend is already in milliseconds (e.g. 56400000 = ~15.67 hours)
export function setJWTToken(token: string, expirationTime?: number) {
  localStorage.setItem(JWT_TOKEN_KEY, token);
  if (expirationTime) {
    const exp = Date.now() + expirationTime;
    localStorage.setItem(JWT_TOKEN_EXP_KEY, exp.toString());
  }
}

export function getJWTToken(): string | null {
  return localStorage.getItem(JWT_TOKEN_KEY);
}

// The refreshed JWT lives in an HttpOnly cookie, so only its expiry is visible to the app.
export function setJWTExpiry(expirationTime?: number) {
  if (expirationTime) {
    const exp = Date.now() + expirationTime;
    localStorage.setItem(JWT_TOKEN_EXP_KEY, exp.toString());
  }
}

export function removeJWTToken() {
  localStorage.removeItem(JWT_TOKEN_KEY);
  localStorage.removeItem(JWT_TOKEN_EXP_KEY);
}

export function getJWTExpiry(): number | null {
  const exp = localStorage.getItem(JWT_TOKEN_EXP_KEY);
  return exp ? parseInt(exp, 10) : null;
}

export function isJWTExpired(): boolean {
  const exp = localStorage.getItem(JWT_TOKEN_EXP_KEY);
  if (!exp) return false;
  return Date.now() > parseInt(exp, 10);
}
